import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TRouter } from '@/common/basis/types/trouter';
import { removeCookieUserToken } from '@/common/utils/cookies';

function App(props: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void; children: React.ReactNode }) {
  const isOpen = props.isOpen;
  const setIsOpen = props.setIsOpen;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal cancelText={t('cancel')} closable={false} footer={null} okText={t('confirm')} open={isOpen} width={440}>
      <div>
        <div className='pb-3 pt-4 text-center text-[14px] text-[#888]'>
          <div>{props.children}</div>
        </div>
        <div className='mx-auto my-4 flex items-center justify-center'>
          <Button
            onClick={() => {
              setIsOpen(false);
              removeCookieUserToken();
              navigate(TRouter.ROUTE_LOGIN, { replace: true });
            }}
            type='primary'
          >
            <span>{t('meKnow')}</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default App;
